<template>
  <div class="tutorial-main-page row-block default-shadow">
    <div class="fixed-container col-block">
      <div :style="{ height: '30px' }"></div>
      <img :style="{ width: '250px', height: '421px' }" :src="require('../../assets/images/search-man.png')">
      <div :style="{ flex: 1 }"></div>
    </div>
    <div v-if="renderItem && display && toggle" class="tutorial-block row-block">
      <div class="content-container col-block" :style="{ flex: 1 }">
        <div id="農產業貿易潛力分析平台" v-if="renderItem['農產業貿易潛力分析平台']" class="tutorial-block col-block">
          <div class="tutorial-title-container row-block" :class="{ active: display['農產業貿易潛力分析平台'] || display['農產業貿易潛力分析平台'] === null, display: display['農產業貿易潛力分析平台'] !== null }" @click="e => display['農產業貿易潛力分析平台'] !== null && (display['農產業貿易潛力分析平台'] = !display['農產業貿易潛力分析平台'])">
            <div class="tutorial-title">農產業貿易潛力分析平台 AgriTrade</div>
            <template v-if="display['農產業貿易潛力分析平台'] !== null">
              <div :style="{ width: '15px' }"></div>
              <img :src="require('../../assets/images/tutorial-display-icon.svg')" alt="">
            </template>
            <div :style="{ flex: 1 }"></div>
          </div>
          <template v-if="display['農產業貿易潛力分析平台'] || display['農產業貿易潛力分析平台'] === null">
            <div :style="{ height: '10px' }"></div>
            <div class="tutorial-content-container">
              <div class="tutorial-content">因技術與市場開放影響下，各國對於水果的進口需求增加，蔬果成為全球化商業運銷系統中的重要商品，此外，我國農業機械也逐漸於國際市場中展現實力，而要能具有外銷競爭力且能持續經營，出口者要同時擁有穩定品質、價格與數量的產品供應能力，並且要能敏銳掌握目標市場需求變化並隨之調整，因此對於不是全球運籌跨國企業的貿易商與小農生產結構的國家而言，要成功進入國際市場並能於重重挑戰中勝出，並不是一件容易的事情，需要花費時間整合與推動供應鏈密切合作，也要花費時間蒐集與整理各種市場資料，因此提供給產業與專家，能快速掌握市場的分析工具十分重要。此平台的目標為快速彙整與計算評估指標，提供產業與專家團隊，分析比較結果圖表與市場報告，輔助團隊快速掌握目標市場概況並能從平台隨時掌握市場變化趨勢，讓使用者在綜合資訊輔助下，了解您最有機會獲利的目標市場。本平台目前提供的工具有：市場吸引力分析工具、市場競爭力分析工具、零售價格分析工具與分析報告瀏覽功能。</div>
            </div>
          </template>
        </div>
        <div id="市場吸引力分析" v-if="renderItem['市場吸引力分析']" class="tutorial-block col-block">
          <div class="tutorial-title-container row-block" :class="{ active: display['市場吸引力分析'] || display['市場吸引力分析'] === null, display: display['市場吸引力分析'] !== null }" @click="e => display['市場吸引力分析'] !== null && (display['市場吸引力分析'] = !display['市場吸引力分析'])">
            <div
              class="tutorial-title"
              v-html="{
                normal: '農產品的市場吸引力',
                tool: '農業機械的市場吸引力'
              }[type] || '市場吸引力分析'"
            ></div>
            <template v-if="display['市場吸引力分析'] !== null">
              <div :style="{ width: '15px' }"></div>
              <img :src="require('../../assets/images/tutorial-display-icon.svg')" alt="">
            </template>
            <div :style="{ flex: 1 }"></div>
          </div>
          <template v-if="display['市場吸引力分析']">
            <div :style="{ height: '10px' }"></div>
            <div class="tutorial-content-container block">
              <template v-if="type !== 'tool'">
                <div v-if="!type" class="tutorial-content-title">農產品的市場吸引力</div>
                <div class="tutorial-content">對農產品而言，市場可以視為區域、國家、特定一群消費者，一個具有吸引力的市場，表示進入市場後可以為事業帶來長期獲利，本平台市場吸引力分析工具為針對國家層面的數據進行分析，可提供做為篩選目標市場的工具，用以了解不同國家對您預計出口產品之吸引力，市場吸引力分析可回答以下問題：</div>
                <div class="tutorial-lists">
                  <div class="list"><b>1. 消費者是否具備消費能力？</b></div>
                  <div class="list-content">人均國內生產總值，表示消費能力越佳，則市場吸引力越大。</div>
                  <div class="list"><b>2. 市場的規模大小？</b></div>
                  <div class="list-content">人口數越多、產品市場規模越大、產品進口值越高、產品市場占有率越高，則市場吸引力越大。</div>
                  <div class="list"><b>3. 市場是否已經為飽和市場？ 是否還有成長空間？</b></div>
                  <div class="list-content">進口市場成長趨勢、進口市場表現、市場相對成長強度越大，則市場吸引力越大。</div>
                  <div class="list"><b>4. 市場是否能為業者帶來利潤？</b></div>
                  <div class="list-content">市場開放程度以關稅評估，關稅越低則市場吸引力越大，市場相對優惠關稅為前五大進口國關稅平均與台灣關稅差異，市場相對優惠關稅數值越大則市場吸引力越大。</div>
                </div>
                <div :style="{ height: '20px' }"></div>
              </template>
              <template v-if="type !== 'normal'">
                <div v-if="!type" class="tutorial-content-title">農業機械的市場吸引力</div>
                <div class="tutorial-content">農業機械的市場吸引力可提供做為市場篩選之工具，用以了解此市場對台灣出口產品之吸引力，市場吸引力分析可回答以下問題：</div>
                <div class="tutorial-lists">
                  <div class="list"><b>1. 消費水準與經濟發展程度?</b></div>
                  <div class="list-content">人均國內生產總值與本地居民總收入越高，表示市場吸引力越大。</div>
                  <div class="list"><b>2. 市場的規模大小？</b></div>
                  <div class="list-content">出口值、農業人口比率越低則市場吸引力越大，耕地面積、平均農業人口耕地面積、進口值、佔全球市場佔有率越高則市場吸引力越大。</div>
                  <div class="list"><b>3. 市場是否已經為飽和市場？是否還有成長空間？</b></div>
                  <div class="list-content">進口市場成長趨勢、農業人口比率趨勢、進口市場表現、市場相對成長強度越大則吸引力越大。</div>
                  <div class="list"><b>4. 市場是否能為業者帶來利潤？</b></div>
                  <div class="list-content">市場開放程度以關稅評估，關稅越低則市場吸引力越大，市場相對優惠關稅為前五大進口國關稅平均與台灣關稅差異，市場相對優惠關稅數值越大則市場吸引力越大。</div>
                </div>
                <div :style="{ height: '20px' }"></div>
              </template>
              <div class="tutorial-content">本平台市場吸引力分析可針對您選擇的產品與年份，在資料庫中快速彙整與計算市場吸引力評估指標，並依國家間市場吸引力高低顯示排序前20名國家於平台，此外市場吸引力工具還提供您可刪除與加權不同指標的功能，動態計算調整前20個對您選擇的產品最具吸引力的國家的排序。本分析功能也提供您針對分析結果進行繪圖，讓您可以自行選擇不同指標製作累計長條圖、散布圖、泡泡圖與雷達圖，產出更具策略涵意之分析結果。</div>
              <div class="tutorial-content">如您想要了解特定國家，歷年市場吸引力指標變化趨勢，可點選國家名稱進入單一國家歷年市場吸引力分析結果，此處您也可以使用平台提供的繪圖功能，繪製出您有興趣的國家在不同年度的市場吸引力指標變化比較結果，輔助您掌握趨勢變化。</div>
            </div>
          </template>
        </div>
        <div id="市場吸引力指標" v-if="renderItem['市場吸引力指標']" class="tutorial-block col-block">
          <div class="tutorial-title-container row-block" :class="{ active: display['市場吸引力指標'] || display['市場吸引力指標'] === null, display: display['市場吸引力指標'] !== null }" @click="e => display['市場吸引力指標'] !== null && (display['市場吸引力指標'] = !display['市場吸引力指標'])">
            <div class="tutorial-title">市場吸引力指標</div>
            <template v-if="display['市場吸引力指標'] !== null">
              <div :style="{ width: '15px' }"></div>
              <img :src="require('../../assets/images/tutorial-display-icon.svg')" alt="">
            </template>
            <div :style="{ flex: 1 }"></div>
          </div>
          <template v-if="display['市場吸引力指標'] || display['市場吸引力指標'] === null">
            <div :style="{ height: '10px' }"></div>
            <div class="tutorial-content-container">
              <div class="tutorial-subcontent-container">
                <div class="tutorial-subtitle-continaer">
                  <div class="tutorial-subtitle">農產品使用的吸引力指標</div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div :style="{ height: '10px' }"></div>
                <div class="tutorial-subcontent-block card row-block">
                  <div class="tutorial-card-container" v-for="(card, index) in tutorialCards['農產品使用的吸引力指標']" :key="index" :style="{ width: toggle['農產品使用的吸引力指標'] === card.value ? '33.33333%' : '33.33333%' }">
                    <div class="tutorial-card-block row-block" v-if="toggle['農產品使用的吸引力指標'] !== card.value" @click="e => toggleCard('農產品使用的吸引力指標', card.value)">
                      <div class="tutorial-card-title">{{ card.title }}</div>
                      <img :src="require('../../assets/images/tutorial-card-display-icon.svg')" alt="">
                    </div>
                    <div class="tutorial-card-content-block col-block" v-else @click="e => toggleCard('農產品使用的吸引力指標', card.value)">
                      <div class="tutorial-card-content-title-container row-block">
                        <div class="tutorial-card-content-title">{{ card.title }}</div>
                        <img :src="require('../../assets/images/tutorial-card-display-icon.svg')" alt="">
                      </div>
                      <div :style="{ height: '10px' }"></div>
                      <div
                        class="tutorial-card-content-container"
                        v-html="card.content"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div :style="{ height: '20px' }"></div>
              <div class="tutorial-subcontent-container">
                <div class="tutorial-subtitle-continaer">
                  <div class="tutorial-subtitle">農業機械使用的吸引力指標</div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div :style="{ height: '10px' }"></div>
                <div class="tutorial-subcontent-block card row-block">
                  <div class="tutorial-card-container" v-for="(card, index) in tutorialCards['農業機械使用的吸引力指標']" :key="index" :style="{ width: toggle['農業機械使用的吸引力指標'] === card.value ? '33.33333%' : '33.33333%' }">
                    <div class="tutorial-card-block row-block" v-if="toggle['農業機械使用的吸引力指標'] !== card.value" @click="e => toggleCard('農業機械使用的吸引力指標', card.value)">
                      <div class="tutorial-card-title">{{ card.title }}</div>
                      <img :src="require('../../assets/images/tutorial-card-display-icon.svg')" alt="">
                    </div>
                    <div class="tutorial-card-content-block col-block" v-else @click="e => toggleCard('農業機械使用的吸引力指標', card.value)">
                      <div class="tutorial-card-content-title-container row-block">
                        <div class="tutorial-card-content-title">{{ card.title }}</div>
                        <img :src="require('../../assets/images/tutorial-card-display-icon.svg')" alt="">
                      </div>
                      <div :style="{ height: '10px' }"></div>
                      <div
                        class="tutorial-card-content-container"
                        v-html="card.content"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div id="市場吸引力操作教學說明" v-if="renderItem['市場吸引力操作教學說明']" class="tutorial-block col-block">
          <div class="tutorial-title-container row-block" :class="{ active: display['市場吸引力操作教學說明'] || display['市場吸引力操作教學說明'] === null, display: display['市場吸引力操作教學說明'] !== null }" @click="e => display['市場吸引力操作教學說明'] !== null && (display['市場吸引力操作教學說明'] = !display['市場吸引力操作教學說明'])">
            <div class="tutorial-title">市場吸引力操作教學說明</div>
            <template v-if="display['市場吸引力操作教學說明'] !== null">
              <div :style="{ width: '15px' }"></div>
              <img :src="require('../../assets/images/tutorial-display-icon.svg')" alt="">
            </template>
            <div :style="{ flex: 1 }"></div>
          </div>
          <template v-if="display['市場吸引力操作教學說明'] || display['市場吸引力操作教學說明'] === null">
            <div :style="{ height: '10px' }"></div>
            <div class="tutorial-content-container">
              <div class="tutorial-subcontent-container">
                <div class="tutorial-subcontent-block img row-block">
                  <div class="tutorial-img-container">
                    <div class="tutorial-img-block row-block stretch" v-for="(img, index) in tutorialImgs['市場吸引力操作教學說明']" :key="index">
                      <div class="content-container" :style="{ flex: 1 }">
                        <div class="content-title" v-html="img.title"></div>
                        <div :style="{ height: '10px' }"></div>
                        <template v-if="img.description">
                          <div class="content-description" v-html="img.description"></div>
                          <div :style="{ height: '10px' }"></div>
                        </template>
                        <div class="content-items col-block">
                          <div class="content-item-block row-block" v-for="(item, iindex) in img.items" :key="iindex">
                            <div class="content-item-number center-block">{{ iindex + 1 }}</div>
                            <div :style="{ width: '5px' }"></div>
                            <div class="content-item-contents col-block" :style="{ flex: 1 }">
                              <div class="content-item-content" v-for="(content, cindex) in item.contents" :key="cindex" v-html="content"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div :style="{ width: '20px' }"></div>
                      <div class="img-container" :style="{ width: '745px' }">
                        <img :src="img.img" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div id="市場競爭力分析" v-if="renderItem['市場競爭力分析']" class="tutorial-block col-block">
          <div class="tutorial-title-container row-block" :class="{ active: display['市場競爭力分析'] || display['市場競爭力分析'] === null, display: display['市場競爭力分析'] !== null }" @click="e => display['市場競爭力分析'] !== null && (display['市場競爭力分析'] = !display['市場競爭力分析'])">
            <div
              class="tutorial-title"
              v-html="{
                normal: '農產品的市場競爭力',
                tool: '農業機械的市場競爭力'
              }[type] || '市場競爭力分析'"
            ></div>
            <template v-if="display['市場競爭力分析'] !== null">
              <div :style="{ width: '15px' }"></div>
              <img :src="require('../../assets/images/tutorial-display-icon.svg')" alt="">
            </template>
            <div :style="{ flex: 1 }"></div>
          </div>
          <template v-if="display['市場競爭力分析']">
            <div :style="{ height: '10px' }"></div>
            <div class="tutorial-content-container block">
              <template v-if="type !== 'tool'">
                <div v-if="!type" class="tutorial-content-title">農產品的市場競爭力</div>
                <div class="tutorial-content">對農產品而言全球運銷越來越頻繁，各種運銷技術進步，多數蔬果包括亞熱帶或熱帶果品都已成為重要各國全球貿易商品，對我國而言，外銷目標市場競爭越來越競爭，因此事先評估進入後會遇到的競爭國家，並時刻關注競爭國家動態，十分的重要性。本平台市場競爭力分析，可使用數個不同指標評估，並讓使用者依專業看法組合指標，藉此評估進入產品進入您有興趣的市場後，與他國的競爭力差異。</div>
                <div class="tutorial-lists">
                  <div class="list"><b>1. 產量與單位面積產量：</b>穩定且大量的生產量是評估競爭力的重要指標項目，而單位面積產量越高代表生產技術較成熟具優勢。</div>
                  <div class="list"><b>2. 生產者價格、進口單價與市場距離：</b>生產者價格若越低代表生產成本越低，生產成本越低的產品越有競爭優勢，進口單價亦是，此外因生鮮蔬果長途運輸不易，因此進出口國家距離近，較具競爭優勢。</div>
                  <div class="list"><b>3. 貿易密集度(TII)與顯示性比較利益指數(RCA)：</b>貿易密集度主要是評估競爭國與目標市場國間貿易關係強弱，若數值越高則代表該競爭國與目標市場的貿易關係密切，越具備市場競爭力；顯示性比較利益指數則用以了解出口強度，若數值越高則代表競爭國出口強度高於世界平均，越具備市場競爭力。</div>
                </div>
                <div :style="{ height: '20px' }"></div>
              </template>
              <template v-if="type !== 'normal'">
                <div v-if="!type" class="tutorial-content-title">農業機械的市場競爭力</div>
                <div class="tutorial-content">因勞力成本不斷上揚，且消費者越來越重視產品品質，開發中國家農產業也逐漸使用機械設備協助生產過程與採後處理作業，對我國而言，以開發中國家做為農業機械與設備外銷目標國，為重要策略。事先評估進入後會遇到的競爭國家，並時刻關注競爭國家動態，十分重要。本平台市場競爭力分析，可使用數個不同指標評估，並讓使用者依專業看法組合指標，藉此評估產品進入您有興趣的市場後，與他國的競爭力差異，本市場競爭力分析可針對某一目標市場，評估台灣與其他競爭國的競爭力現況。</div>
                <div class="tutorial-lists">
                </div>
                <div :style="{ height: '20px' }"></div>
              </template>
              <div class="tutorial-content">本平台市場競爭力分析可針對您選擇的產品、目標市場國與年份，在資料庫中快速彙整與計算市場競爭力評估指標，並依目標市場國的進口值前5名的國家與我國顯示競爭力指標分數與排名(未加權狀態)，此外市場吸引力工具還提供您可刪除與加權不同指標的功能，動態計算調整該市場的5(6)個競爭國的競爭力排序。本分析功能也提供您針對分析結果進行繪圖，讓您可以自行選擇不同指標製作累計長條圖、散布圖、泡泡圖與雷達圖，產出更具策略涵意之分析結果。如您想要了解特定國家，歷年市場吸引力指標變化趨勢，可點選國家名稱進入單一國家歷年市場競爭力分析結果，此處您也可以使用平台提供的繪圖功能，繪製出您有興趣的國家在不同年度的市場競爭力指標變化比較結果，輔助您掌握趨勢變化。</div>
            </div>
          </template>
        </div>
        <div id="市場競爭力指標" v-if="renderItem['市場競爭力指標']" class="tutorial-block col-block">
          <div class="tutorial-title-container row-block" :class="{ active: display['市場競爭力指標'] || display['市場競爭力指標'] === null, display: display['市場競爭力指標'] !== null }" @click="e => display['市場競爭力指標'] !== null && (display['市場競爭力指標'] = !display['市場競爭力指標'])">
            <div class="tutorial-title">市場競爭力指標</div>
            <template v-if="display['市場競爭力指標'] !== null">
              <div :style="{ width: '15px' }"></div>
              <img :src="require('../../assets/images/tutorial-display-icon.svg')" alt="">
            </template>
            <div :style="{ flex: 1 }"></div>
          </div>
          <template v-if="display['市場競爭力指標'] || display['市場競爭力指標'] === null">
            <div :style="{ height: '10px' }"></div>
            <div class="tutorial-content-container">
              <div class="tutorial-subcontent-container">
                <div class="tutorial-subtitle-continaer">
                  <div class="tutorial-subtitle">農產品使用的競爭力指標</div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div :style="{ height: '10px' }"></div>
                <div class="tutorial-subcontent-block card row-block">
                  <div class="tutorial-card-container" v-for="(card, index) in tutorialCards['農產品使用的競爭力指標']" :key="index" :style="{ width: toggle['農產品使用的競爭力指標'] === card.value ? '33.33333%' : '33.33333%' }">
                    <div class="tutorial-card-block row-block" v-if="toggle['農產品使用的競爭力指標'] !== card.value" @click="e => toggleCard('農產品使用的競爭力指標', card.value)">
                      <div class="tutorial-card-title">{{ card.title }}</div>
                      <img :src="require('../../assets/images/tutorial-card-display-icon.svg')" alt="">
                    </div>
                    <div class="tutorial-card-content-block col-block" v-else @click="e => toggleCard('農產品使用的競爭力指標', card.value)">
                      <div class="tutorial-card-content-title-container row-block">
                        <div class="tutorial-card-content-title">{{ card.title }}</div>
                        <img :src="require('../../assets/images/tutorial-card-display-icon.svg')" alt="">
                      </div>
                      <div :style="{ height: '10px' }"></div>
                      <div
                        class="tutorial-card-content-container"
                        v-html="card.content"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div :style="{ height: '20px' }"></div>
              <div class="tutorial-subcontent-container">
                <div class="tutorial-subtitle-continaer">
                  <div class="tutorial-subtitle">農業機械使用的競爭力指標</div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div :style="{ height: '10px' }"></div>
                <div class="tutorial-subcontent-block card row-block">
                  <div class="tutorial-card-container" v-for="(card, index) in tutorialCards['農業機械使用的競爭力指標']" :key="index" :style="{ width: toggle['農業機械使用的競爭力指標'] === card.value ? '33.33333%' : '33.33333%' }">
                    <div class="tutorial-card-block row-block" v-if="toggle['農業機械使用的競爭力指標'] !== card.value" @click="e => toggleCard('農業機械使用的競爭力指標', card.value)">
                      <div class="tutorial-card-title">{{ card.title }}</div>
                      <img :src="require('../../assets/images/tutorial-card-display-icon.svg')" alt="">
                    </div>
                    <div class="tutorial-card-content-block col-block" v-else @click="e => toggleCard('農業機械使用的競爭力指標', card.value)">
                      <div class="tutorial-card-content-title-container row-block">
                        <div class="tutorial-card-content-title">{{ card.title }}</div>
                        <img :src="require('../../assets/images/tutorial-card-display-icon.svg')" alt="">
                      </div>
                      <div :style="{ height: '10px' }"></div>
                      <div
                        class="tutorial-card-content-container"
                        v-html="card.content"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div id="市場競爭力操作教學說明" v-if="renderItem['市場競爭力操作教學說明']" class="tutorial-block col-block">
          <div class="tutorial-title-container row-block" :class="{ active: display['市場競爭力操作教學說明'] || display['市場競爭力操作教學說明'] === null, display: display['市場競爭力操作教學說明'] !== null }" @click="e => display['市場競爭力操作教學說明'] !== null && (display['市場競爭力操作教學說明'] = !display['市場競爭力操作教學說明'])">
            <div class="tutorial-title">市場競爭力操作教學說明</div>
            <template v-if="display['市場競爭力操作教學說明'] !== null">
              <div :style="{ width: '15px' }"></div>
              <img :src="require('../../assets/images/tutorial-display-icon.svg')" alt="">
            </template>
            <div :style="{ flex: 1 }"></div>
          </div>
          <template v-if="display['市場競爭力操作教學說明'] || display['市場競爭力操作教學說明'] === null">
            <div :style="{ height: '10px' }"></div>
            <div class="tutorial-content-container">
              <div class="tutorial-subcontent-container">
                <div class="tutorial-subcontent-block img row-block">
                  <div class="tutorial-img-container">
                    <div class="tutorial-img-block row-block stretch" v-for="(img, index) in tutorialImgs['市場競爭力操作教學說明']" :key="index">
                      <div class="content-container" :style="{ flex: 1 }">
                        <div class="content-title" v-html="img.title"></div>
                        <div :style="{ height: '10px' }"></div>
                        <template v-if="img.description">
                          <div class="content-description" v-html="img.description"></div>
                          <div :style="{ height: '10px' }"></div>
                        </template>
                        <div class="content-items col-block">
                          <div class="content-item-block row-block" v-for="(item, iindex) in img.items" :key="iindex">
                            <div class="content-item-number center-block">{{ iindex + 1 }}</div>
                            <div :style="{ width: '5px' }"></div>
                            <div class="content-item-contents col-block" :style="{ flex: 1 }">
                              <div class="content-item-content" v-for="(content, cindex) in item.contents" :key="cindex" v-html="content"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div :style="{ width: '20px' }"></div>
                      <div class="img-container" :style="{ width: '745px' }">
                        <img :src="img.img" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div id="零售價格分析與指標" v-if="renderItem['零售價格分析與指標']" class="tutorial-block col-block">
          <div class="tutorial-title-container row-block" :class="{ active: display['零售價格分析與指標'] || display['零售價格分析與指標'] === null, display: display['零售價格分析與指標'] !== null }" @click="e => display['零售價格分析與指標'] !== null && (display['零售價格分析與指標'] = !display['零售價格分析與指標'])">
            <div class="tutorial-title">零售價格分析與指標</div>
            <template v-if="display['零售價格分析與指標'] !== null">
              <div :style="{ width: '15px' }"></div>
              <img :src="require('../../assets/images/tutorial-display-icon.svg')" alt="">
            </template>
            <div :style="{ flex: 1 }"></div>
          </div>
          <template v-if="display['零售價格分析與指標']">
            <div :style="{ height: '10px' }"></div>
            <div class="tutorial-content-container block">
              <div class="tutorial-content">零售價格分析模組，可比較不同通路型態、國家、產品形式之產品售價差異，讓使用者可評估產品定位，此外，使用者可從產品照片了解產品包裝方式、陳列以及產品外觀，藉以評估產品市場定位。</div>
            </div>
            <div :style="{ height: '20px' }"></div>
            <div class="tutorial-content-container">
              <div class="tutorial-subcontent-container">
                <div class="tutorial-subcontent-block card row-block">
                  <div class="tutorial-card-container" v-for="(card, index) in tutorialCards['零售價格分析與指標']" :key="index" :style="{ width: toggle['零售價格分析與指標'] === card.value ? '33.33333%' : '33.33333%' }">
                    <div class="tutorial-card-block row-block" v-if="toggle['零售價格分析與指標'] !== card.value" @click="e => toggleCard('零售價格分析與指標', card.value)">
                      <div class="tutorial-card-title">{{ card.title }}</div>
                      <img :src="require('../../assets/images/tutorial-card-display-icon.svg')" alt="">
                    </div>
                    <div class="tutorial-card-content-block col-block" v-else @click="e => toggleCard('零售價格分析與指標', card.value)">
                      <div class="tutorial-card-content-title-container row-block">
                        <div class="tutorial-card-content-title">{{ card.title }}</div>
                        <img :src="require('../../assets/images/tutorial-card-display-icon.svg')" alt="">
                      </div>
                      <div :style="{ height: '10px' }"></div>
                      <div
                        class="tutorial-card-content-container"
                        v-html="card.content"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div id="零售價格分析操作教學說明" v-if="renderItem['零售價格分析操作教學說明']" class="tutorial-block col-block">
          <div class="tutorial-title-container row-block" :class="{ active: display['零售價格分析操作教學說明'] || display['零售價格分析操作教學說明'] === null, display: display['零售價格分析操作教學說明'] !== null }" @click="e => display['零售價格分析操作教學說明'] !== null && (display['零售價格分析操作教學說明'] = !display['零售價格分析操作教學說明'])">
            <div class="tutorial-title">零售價格分析操作教學說明</div>
            <template v-if="display['零售價格分析操作教學說明'] !== null">
              <div :style="{ width: '15px' }"></div>
              <img :src="require('../../assets/images/tutorial-display-icon.svg')" alt="">
            </template>
            <div :style="{ flex: 1 }"></div>
          </div>
          <template v-if="display['零售價格分析操作教學說明'] || display['零售價格分析操作教學說明'] === null">
            <div :style="{ height: '10px' }"></div>
            <div class="tutorial-content-container">
              <div class="tutorial-subcontent-container">
                <div class="tutorial-subcontent-block img row-block">
                  <div class="tutorial-img-container">
                    <div class="tutorial-img-block row-block stretch" v-for="(img, index) in tutorialImgs['零售價格分析操作教學說明']" :key="index">
                      <div class="content-container" :style="{ flex: 1 }">
                        <div class="content-title" v-html="img.title"></div>
                        <div :style="{ height: '10px' }"></div>
                        <template v-if="img.description">
                          <div class="content-description" v-html="img.description"></div>
                          <div :style="{ height: '10px' }"></div>
                        </template>
                        <div class="content-items col-block">
                          <div class="content-item-block row-block" v-for="(item, iindex) in img.items" :key="iindex">
                            <div class="content-item-number center-block">{{ iindex + 1 }}</div>
                            <div :style="{ width: '5px' }"></div>
                            <div class="content-item-contents col-block" :style="{ flex: 1 }">
                              <div class="content-item-content" v-for="(content, cindex) in item.contents" :key="cindex" v-html="content"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div :style="{ width: '20px' }"></div>
                      <div class="img-container" :style="{ width: '745px' }">
                        <img :src="img.img" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div id="分析報告與操作說明" v-if="renderItem['分析報告與操作說明']" class="tutorial-block col-block">
          <div class="tutorial-title-container row-block" :class="{ active: display['分析報告與操作說明'] || display['分析報告與操作說明'] === null, display: display['分析報告與操作說明'] !== null }" @click="e => display['分析報告與操作說明'] !== null && (display['分析報告與操作說明'] = !display['分析報告與操作說明'])">
            <div class="tutorial-title">分析報告與操作說明</div>
            <template v-if="display['分析報告與操作說明'] !== null">
              <div :style="{ width: '15px' }"></div>
              <img :src="require('../../assets/images/tutorial-display-icon.svg')" alt="">
            </template>
            <div :style="{ flex: 1 }"></div>
          </div>
          <template v-if="display['分析報告與操作說明']">
            <div :style="{ height: '10px' }"></div>
            <div class="tutorial-content-container block">
              <div class="tutorial-content">時刻掌握想要進入或已經在經營的海外市場環境變化，再進一步評估此變化對事業的影響程度並隨之調整事業方向，對能長期獲利有正面幫助。環境變化包括:消費者與市場偏好、競爭對手動態等，此分析平台可提供報告，讓您可於市場吸引力與市場競爭力分析時使用。</div>
            </div>
            <div :style="{ height: '20px' }"></div>
            <div class="tutorial-content-container">
              <div class="tutorial-subcontent-container">
                <div class="tutorial-subcontent-block img row-block">
                  <div class="tutorial-img-container">
                    <div class="tutorial-img-block row-block stretch" v-for="(img, index) in tutorialImgs['分析報告與操作說明']" :key="index">
                      <div class="content-container" :style="{ flex: 1 }">
                        <div class="content-title" v-html="img.title"></div>
                        <div :style="{ height: '10px' }"></div>
                        <template v-if="img.description">
                          <div class="content-description" v-html="img.description"></div>
                          <div :style="{ height: '10px' }"></div>
                        </template>
                        <div class="content-items col-block">
                          <div class="content-item-block row-block" v-for="(item, iindex) in img.items" :key="iindex">
                            <div class="content-item-number center-block">{{ iindex + 1 }}</div>
                            <div :style="{ width: '5px' }"></div>
                            <div class="content-item-contents col-block" :style="{ flex: 1 }">
                              <div class="content-item-content" v-for="(content, cindex) in item.contents" :key="cindex" v-html="content"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div :style="{ width: '20px' }"></div>
                      <div class="img-container" :style="{ width: '745px' }">
                        <img :src="img.img" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ width: '30px' }"></div>
      <div class="img-container col-block" :style="{ opacity: 0 }">
        <div :style="{ height: '30px' }"></div>
        <div :style="{ width: '250px' }"></div>
        <div :style="{ flex: 1 }"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: () => null
    },
    params: {
      type: Object,
      default: () => ({})
    },
    scrollToID: {
      type: String,
      default: () => null
    }
  },
  data () {
    return {
      renderItem: null,
      display: null,
      toggle: null
    }
  },
  computed: {
    tutorialCards () {
      return {
        '農產品使用的吸引力指標': [
          {
            title: '產量(公噸)',
            value: '產量(公噸)',
            content: '當一個國家對於產品的需求大於國內可生產供應數量時，會傾向進口產品補足國內需求，顯示這個國家對此產品具有高度市場吸引力，因此，採用產量作為市場吸引力評估指標的意涵為，該目標市場產量越低可視為對其他國家進口產品的需求越大，市場吸引力越高。<b>本平台產量數據來源為聯合國農糧組織網站</b>，<span class=\'alert\'>部分產品的分類方式與國際貿易中心不同，使用時請注意網站提醒。</span>'
          },
          {
            title: '出口值 (千美元)',
            value: '出口值 (千美元)',
            content: '當一個國家能出口產品可視為該國家對該產品的真實需求並非在其國內市場，而是其他國外市場，因此，採用出口值作為市場吸引力評估指標的意涵為，該目標市場出口量越高可視為其對於從其他國家進口產品的需求越低，市場吸引力越低。<b>本平台出口值數據來源為國際貿易中心。</b>'
          },
          {
            title: '進口值 (千美元)',
            value: '進口值 (千美元)',
            content: '當一個國家對進口產品的金額高可視為該國家對產品需求大且具獲利機會，因此，採用進口值作為市場吸引力評估指標的意涵為，該目標市場進口值越高可視為該國家對產品的需求越高，市場吸引力越高。<b>本平台進口值數據來源為國際貿易中心。</b>'
          },
          {
            title: '市場規模 (千美元)',
            value: '市場規模 (千美元)',
            content: '市場規模可顯示一個國家的需求程度，市場規模越大，進口市場後可獲利的機會越高，因此採用市場規模作為市場吸引力評估指標意涵為，該目標市場規模越大，獲利機會越大，市場吸引力越高。<b>本平台市場規模數值由之產值+進口值-出口值 計算獲得。</b>'
          },
          {
            title: '進口市場成長趨勢(%)',
            value: '進口市場成長趨勢(%)',
            content: '年成長率可用來了解該國進口市場處於何種時期(萌芽、成長、成熟與衰退期)，並評估該市場未來發展前景，成長趨勢越高則發展前景越佳，因此採用進口市場成長趨勢作為市場吸引力評估指標意涵為，市場年成長趨勢越高且處於成長期，市場吸引力越高，<b>本平台進口市場成長趨勢由 (本年度之總進口值 - 去年度之總進口值) / 去年度之總進口值</b> 計算獲得。'
          },
          {
            title: '貿易專業化指數TSI',
            value: '貿易專業化指數TSI',
            content: 'TSI 可用以了解該國家產品之淨出口或淨進口狀況，如進出口平衡狀態則貿易專業化指標為零，而如該國家以出口為導向，則貿易專業化指數為正值則顯示出口大於進口，該產品偏向出口導向，因此採用貿易專業化指數作為市場吸引力評估指標意涵為，貿易專業化指數為正值則出口量能越強，則市場吸引力越低，貿易專業化指數為負值擇進口為多，市場吸引力越高，<b>本平台貿易專業化指數由 (目標市場國之產品總出口值 - 目標市場國之產品總進口值) / (目標市場國之產品總出口值 + 目標市場國之產品總進口值)</b> 計算獲得。'
          },
          {
            title: '市場距離(公里)',
            value: '市場距離(公里)',
            content: '蔬果為易腐產品長途運輸不易，運輸過程經營者需承擔高度風險，因此出口目標市場距離越長，則品質耗損風險越高，因此採用目標市場與我國之距離作為市場吸引力評估指標意涵為，市場距離越大則需承擔風險越高，市場吸引力越低。本平台<b>使用google提供的國家間直線距離作為市場距離指標內容。</b>'
          },
          {
            title: '全球貿易市場佔有率(%)',
            value: '全球貿易市場佔有率(%)',
            content: '市場佔有率可用以比較各國對該產品進口值佔全球總進口佔比，該國市場佔有率越高則該國市場在全球進口市場的重要性越高，因此採用全球貿易市場佔有率作為市場吸引力評估指標意涵為，該國家於全球貿易市場佔有率約高，則市場吸引力越高，本平台<b>全球貿易市場佔有率由 (目標市場國之該農產品進口值 / 全球之該農產品進口值)</b> 計算獲得。'
          },
          {
            title: '平均每人GDP(美元)',
            value: '平均每人GDP(美元)',
            content: '人均GDP可用以了解該國家之總體的消費力，一般認為較高人均GDP的國家較有能力能購買價格偏高之進口產品，因此採用平均每人GDP作為市場吸引力評估指標意涵為，該國家人均GDP越高消費力越強，則市場吸引力越高，本平台<b>人均GDP資料數據來源為世界銀行網站。</b>'
          },
          {
            title: '人口數',
            value: '人口數',
            content: '人口數可視為市場規模影響因素，人口數越多代表對於農產品的需求量越多，因此採用人口數作為市場吸引力評估指標意涵為，人口數越多則市場吸引力越高。<b>人口數資料數據來源為世界銀行網站。</b>'
          },
          {
            title: '市場成長相對強度(%)',
            value: '市場成長相對強度(%)',
            content: '市場成長相對強度可使用於比較目標市場進口成長率與全球進口成長率之差異，如該市場進口成長率遠高於全球，顯示該市場需求快速成長，因此採用市場成長相對強度作為市場吸引力評估指標意涵為，市場成長相對強度越高，則市場吸引力越高，本平台<b>市場成長相對強度由 [(本年目標市場國之產品進口值-5年前目標市場國之產品進口值) / (5年前目標市場國之產品進口值)] - [(本年全球之產品進口值-5年前全球之產品進口值) / (5年前全球之產品進口值)]</b> 計算獲得。'
          },
          {
            title: '進口市場表現(%)',
            value: '進口市場表現(%)',
            content: '進口市場表現用於了解我國於目標市場是否仍有成長空間或已經接近市場飽和，進口市場表現指標為「該農產品目標市場佔全球市場佔有率」減去「台灣出口該農產品到目標市場佔台灣該農產品總出口之比例」，以該目標市場佔全球市場比率為指標，比較我國目前出口該市場的佔比是否低於指標 (正值) 或是高於指標 (負值)，因此採用進口市場表現作為市場吸引力評估指標意涵為，數值為正值表示我國在該目標市場出口尚有成長空間，數值為負值則表示成長空間低且可能有依賴目標市場的現象。進口市場表現由 <b>[(目標市場國之該農產品進口值 / 全球之該農產品進口值) - (台灣之該農產品出口至目標市場國之出口值 / 台灣之該農產品總出口值)]</b> 計算獲得。'
          },
          {
            title: '市場開放程度(%)',
            value: '市場開放程度(%)',
            content: '各國間產品關稅為影響農產品貿易重要因子，農產品關稅稅率可視作該國家市場對該產品採開放程度，因此採用進口國關稅作為市場吸引力評估指標意涵為，進口國關稅越高則市場吸引力越低。<b>本平台關稅數據來源為國家貿易中心。</b></br><span class=\'alert\'>注意！</span> 因ITC關稅資料僅有最新年度之資料，並無歷年資料，因此各年度均以最新年度之關稅率作為分析數據之依據。'
          },
          {
            title: '市場相對優惠關稅(%)',
            value: '市場相對優惠關稅(%)',
            content: '比較我國與目標市場前五大進口國平均關稅可了解該市場對我國與其他國家開放程度差異，本平台市場相對優惠關稅由<b>(目標市場國前五大進口國產品之平均關稅率 - 台灣至目標市場國之產品關稅率)</b> 計算獲得，因此採用市場相對優惠關稅作為市場吸引力評估指標意涵為，數值越大顯示市場吸引力越高，市場對我國產品關稅率低於前五大進口國平均關稅率。</br><span class=\'alert\'>注意！</span> 因ITC關稅資料僅有最新年度之資料，並無歷年資料，因此各年度均以最新年度之關稅率作為分析數據之依據。'
          }
        ],
        '農業機械使用的吸引力指標': [
          {
            title: '出口值(千美元)',
            value: '出口值(千美元)',
            content: '當一個國家能出口農機可視為該國家在生產面具備一定的數量與能力，可間接推測這個國家對相同產品的進口需求低，因此，採用出口值作為市場吸引力評估指標的意涵為，該目標市場出口量越高可視為其對於從其他國家進口產品的需求越低，市場吸引力越低，<b>本平台出口值數據來源為國際貿易中心。</b>'
          },
          {
            title: '進口值(千美元)',
            value: '進口值(千美元)',
            content: '當一個國家對進口產品的金額高可視為該國家對產品需求大且具獲利機會，因此，採用進口值作為市場吸引力評估指標的意涵為，該目標市場 進口值越高可視為該國家對農機產品的需求越高，市場吸引力越高，<b>本平台進口值數據來源為國際貿易中心。</b>'
          },
          {
            title: '進口市場成長趨勢(%)',
            value: '進口市場成長趨勢(%)',
            content: '年成長率可用來了解該國進口市場處於何種時期(萌芽、成長、成熟與衰退期)，並評估該市場未來發展前景，成長趨勢越高則發展前景越佳，因此採用進口市場成長趨勢作為市場吸引力評估指標意涵為，市場年成長趨勢越高且處於成長期，市場吸引力越高，本平台進口市場成長趨勢由 <b>(本年度之總進口值 - 去年度之總進口值) / 去年度之總進口值</b> 計算獲得。'
          },
          {
            title: '貿易專業化指數(TSI)',
            value: '貿易專業化指數(TSI)',
            content: '貿易專業化指數可用以了解該國家產品之淨出口或淨進口狀況，如進出口平衡狀態則貿易專業化指標為零，而如該國家以出口為導向，則貿易專業化指數為正值則顯示出口大於進口，該產品偏向出口導向，因此採用貿易專業化指數作為市場吸引力評估指標意涵為，貿易專業化指數為正值則出口量能越強，則市場吸引力越低，貿易專業化指數為負值擇進口為多，市場吸引力越高，本平台貿易專業化指數由 <b>(目標市場國農機出口值-目標市場國農機進口值) / (目標市場國農機出口值+目標市場國農機進口值)</b> 計算獲得。'
          },
          {
            title: '全球貿易市場佔有率(%)',
            value: '全球貿易市場佔有率(%)',
            content: '市場佔有率可用以比較各國對該產品進口值佔全球總進口佔比，該國市場佔有率越高則該國市場在全球進口市場的重要性越高，因此採用全球貿易市場佔有率作為市場吸引力評估指標意涵為，該國家於全球貿易市場佔有率約高，則市場吸引力越高，本平台全球貿易市場佔有率由 <b>(目標市場國農機進口值 / 世界農機進口值)</b> 計算獲得。'
          },
          {
            title: '平均每人GDP(美元)',
            value: '平均每人GDP(美元)',
            content: '人均GDP可用以了解該國家經濟發展情況，一般認為較高人均GDP的國家經濟發展較好，或該國家之勞力薪資水準較高，因此採用平均每人GDP作為市場吸引力評估指標意涵為，該國家人均GDP越高經濟發展越好且農業勞力成本越高，對農機需求越高，市場吸引力越大，<b>本平台人均GDP資料數據來源為世界銀行網站。</b>'
          },
          {
            title: 'GNI (美元)',
            value: 'GNI (美元)',
            content: 'GNI可用以了解該國家經濟發展情況，一般認為GNI高的國家經濟發展較好，或該國家之勞力薪資水準較高，因此採用GNI作為市場吸引力評估指標意涵為，該國家GNI越高經濟發展越好且農業勞力成本越高，對農機需求越高，市場吸引力越大，<b>本平台GNI資料數據來源為世界銀行網站。</b>'
          },
          {
            title: '農業人口比率(%)',
            value: '農業人口比率(%)',
            content: '當一個國家農業人口比率越高，可視為該國家從事農業生產者佔總人口多，農業勞動力充足，因此，採用農業人口比率作為市場吸引力指標的涵意為，該目標市場農業人口比率越高則對農機需求越低，市場吸引力越低，<b>本平農業人口比率資料來源為世界銀行。</b>'
          },
          {
            title: '農業人口比率趨勢',
            value: '農業人口比率趨勢',
            content: '當一個國家農業人口比率逐漸降低，可視為該國家從事農業生產者人口逐漸減少，造成農業勞動力減少，因此，採用農業人口比率趨勢作為市場吸引力指標的意涵為，該目標市場農業人口比率成長趨勢減少則對農機需求越高，市場吸引力越高，農業人口比率趨勢由 <b>[(本年目標市場國之農業人口比率-去年目標市場國之農業人口比率) / 去年目標市場國之農業人口比率]</b> 計算獲得。'
          },
          {
            title: '耕地面積(平方公里)',
            value: '耕地面積(平方公里)',
            content: '當一個國家耕地面積越大可視為，該國家農業生產偏向土地型利用農業生產模式，或該國家視農業為重要經濟活動，因此，採用耕地面積作為市場吸引力指標的涵意為，該目標市場耕地面積越大可視為對農機需求越高，市場吸引力越高，<b>本平台耕地面積數據來源為世界銀行。</b>'
          },
          {
            title: '平均農業人口耕地面積(平方公里/人)',
            value: '平均農業人口耕地面積(平方公里/人)',
            content: '當一個國家平均農業人口耕地面積越大，可視為該國家農業耕作偏向規模較大生產方式，因此，採用平均農業人口耕地面積作為市場吸引力的涵意為，該目標市場平均農業人口耕地面積越高則對農機需求越高，市場吸引力越大，平均農業人口耕地面積由 <b>[目標市場國之耕地面積/(目標市場國之總人口數*目標市場國之農業人口比率)]</b> 計算獲得。'
          },
          {
            title: '市場成長相對強度(%)',
            value: '市場成長相對強度(%)',
            content: '市場成長相對強度可使用於比較目標市場進口成長率與全球進口成長率之差異，如該市場進口成長率遠高於全球，顯示該市場需求快速成長，因刺採用市場成長相對強度作為市場吸引力評估指標意涵為，市場成長相對強度越高，則市場吸引力越高，本平台市場成長相對強度由 <b>[(本年目標市場國之農機進口值-5年前目標市場國之農機進口值) / (5年前目標市場國之農機進口值)] - [(本年全球之農機進口值-5年前全球之農機進口值) / (5年前全球之農機進口值)]</b> 計算獲得。'
          },
          {
            title: '進口市場表現(%)',
            value: '進口市場表現(%)',
            content: '進口市場表現用於了解我國於目標市場是否仍有成長空間或已經接近市場飽和，進口市場表現指標為「該農機產品目標市場佔全球市場佔有率」減去「台灣出口該農機產品到目標市場佔台灣該農產品總出口之比例」，以該目標市場佔全球市場比率為指標，比較我國目前出口該市場的佔比是否低於指標 (正值) 或是高於指標 (負值)，因此採用進口市場表現作為市場吸引力評估指標意涵為，數值為正值表示我國在該目標市場出口尚有成長空間，數值為負值則表示成長空間低且可能有依賴目標市場的現象。進口市場表現由 <b>[(目標市場國之該農機進口值/全球之該農機進口值) - (台灣之該農機出口至目標市場國之出口值/台灣之該農機總出口值)]</b> 計算獲得。'
          },
          {
            title: '市場開放程度(%)',
            value: '市場開放程度(%)',
            content: '各國間產品關稅為影響農機貿易重要因子，農機關稅稅率可視作該國家市場對該產品採開放程度，因此採用進口國關稅作為市場吸引力評估指標意涵為，進口國關稅越高則市場吸引力越低。<b>本平台關稅數據來源為國家貿易中心。</b></br><span class=\'alert\'>注意！</span> 因ITC關稅資料僅有最新年度之資料，並無歷年資料，因此各年度均以最新年度之關稅率作為分析數據之依據。'
          },
          {
            title: '市場相對優惠關稅(%)',
            value: '市場相對優惠關稅(%)',
            content: '比較我國與目標市場前五大進口國平均關稅可了解該市場對我國與其他國家開放程度差異，本平台市場相對優惠關稅由<b>「目標市場國前五大進口國農機之平均關稅率 - 台灣至目標市場國之農機關稅率」</b>計算獲得，因此採用市場相對優惠關稅作為市場吸引力評估指標意涵為，數值越大顯示市場吸引力越高，市場對我國產品關稅率低於前五大進口國平均關稅率。</br><span class=\'alert\'>注意！</span> 因ITC關稅資料僅有最新年度之資料，並無歷年資料，因此各年度均以最新年度之關稅率作為分析數據之依據。'
          }
        ],
        '農產品使用的競爭力指標': [
          {
            title: '產量(公噸)',
            value: '產量(公噸)',
            content: '一個國家農產品產量可用以了解是否具有可外銷的數量與能力，產量越高則代表在外銷供應上與其他國家相較越具有競爭力，因此採用產量作為市場競爭力指標意涵為，產量越高，此國家在外銷目標國的市場競爭力越強。<b>本平台產量數據來源為聯合國農糧組織網站，</b><span class=\'alert\'>部分產品的分類方式與國際貿易中心不同，使用時請注意網站提醒</span>。'
          },
          {
            title: '單位面積產量 (百克/公頃)',
            value: '單位面積產量 (百克/公頃)',
            content: '一個國家農產品單位面積產量可用以了解是否具有可外銷的能力，單位面積產量越高則代表在產品生產技術上與其他國家相較越具有競爭力，因此採用單位面積產量作為市場競爭力指標意涵為，單位面積產量越高，此國家在外銷目標國的市場競爭力越強。<b>本平台產量數據來源為聯合國農糧組織網站，</b><span class=\'alert\'>部分產品的分類方式與國際貿易中心不同，使用時請注意網站提醒</span>。'
          },
          {
            title: '生產者價格 (美元/公噸)',
            value: '生產者價格 (美元/公噸)',
            content: '一個國家生產者價格可視為了解該國生產成本高低的指標，而生產成本高則代表在外銷供應上該國不具價格優勢，因此採用生產者價格作為市場競爭力指標意涵為，生產者價格越高，此國家在外銷目標國的市場競爭力越低。<b>本平台產量數據來源為聯合國農糧組織網站，</b><span class=\'alert\'>部分產品的分類方式與國際貿易中心不同，使用時請注意網站提醒。</span><span class=\'alert\'><b>我國生產者價格部分資料來源為農糧署生產成本調查系統</b></span>。'
          },
          {
            title: '進口單價 (美元/公斤)',
            value: '進口單價 (美元/公斤)',
            content: '一個國家在市場端之進口單價可間接了解，出口國於外銷供應時的成本，而市場進口單價高代表在外銷供應上該國不具價格優勢，因此採用市場進口單價作為市場競爭力指標意涵為，進口單價越高，此國家在外銷目標國的市場競爭力越低。本平台進口單價由 <b>(目標市場國進口競爭國之產品進口值 / 目標市場國進口競爭國之產品進口量)</b> 計算獲得。'
          },
          {
            title: '顯示性比較利益指數 (RCA)',
            value: '顯示性比較利益指數 (RCA)',
            content: 'RCA可用來評估一個國家某項產品出口競爭力表現，RCA指數越高代表該產品出口競爭力越強，因此採用顯示性比較利益指數作為市場競爭力指標意涵為，顯示性比較利益指數越高，此國家在外銷目標國的市場競爭力越高。本平台顯示性比較利益指數由 <b>[(競爭國出口產品至目標市場國總出口值 / 全球出口產品至目標市場總出口值) / (競爭國出口水果 (蔬菜) 至目標市場總出口值 / 全球出口水果 (蔬菜) 至目標市場總出口值)]</b> 計算獲得。'
          },
          {
            title: '貿易密集度指數(TII)',
            value: '貿易密集度指數(TII)',
            content: 'TII可用來評估進口國與出口國之在某個品項的貿易往來程度，貿易往來越多，供應網絡越密切，則出口國在目標市場的競爭力越強，因此採用貿易密集度作為市場競爭力指標意涵為，貿易密集度越高，則此國家在外銷目標國的市場競爭力越高。本平台貿易密集度由 <b>(目標市場進口競爭國之產品總進口值 / 目標市場國進口全球之產品總進口值) / [競爭國出口全球之產品總出口值 / (產品全球總出口值 - 目標市場國出口全球之產品總出口值)]</b> 計算獲得。'
          },
          {
            title: '市場距離(公里)',
            value: '市場距離(公里)',
            content: '蔬果為易腐產品長途運輸不易，運輸過程經營者需承擔高度風險，因此出口目標市場距離越長，則品質耗損風險越高，因此採用競爭國與市場之距離作為市場競爭力評估指標意涵為，競爭國與市場距離越小則需承擔風險越小，市場吸競爭力越高。<b>本平台使用google提供的國家間直線距離作為市場距離指標內容。</b>'
          }
        ],
        '農業機械使用的競爭力指標': [
          {
            title: '進口單價 (美元/公斤)',
            value: '進口單價 (美元/公斤)',
            content: '一個國家在市場端之進口單價可間接了解，出口國於外銷供應時的成本，而市場進口單價高代表在外銷供應上該國不具價格優勢，因此採用市場進口單價作為市場競爭力指標意涵為，進口單價越高，此國家在外銷目標國的市場競爭力越低。本平台進口單價由 <b>(目標市場國進口競爭國之農機進口值 / 目標市場國進口競爭國之農機進口量)</b> 計算獲得。'
          },
          {
            title: '顯示性比較利益指數 (RCA)',
            value: '顯示性比較利益指數 (RCA)',
            content: 'RCA可用來評估一個國家某項產品出口競爭力表現，RCA指數越高代表該產品出口競爭力越強，因此採用顯示性比較利益指數作為市場競爭力指標意涵為，顯示性比較利益指數越高，此國家在外銷目標國的市場競爭力越高。本平台顯示性比較利益指數由 <b>[(競爭國出口農機至目標市場國總出口值 / 全球出口農機至目標市場總出口值) / (競爭國出口農機 (4碼) 至目標市場總出口值/全球出口農機 (4碼) 至目標市場總出口值)]</b> 計算獲得。'
          },
          {
            title: '貿易密集度指數 (TII)',
            value: '貿易密集度指數 (TII)',
            content: 'TII可用來評估進口國與出口國之在某個品項的貿易往來程度，貿易往來越多，供應網絡越密切，則出口國在目標市場的競爭力越強，因此採用貿易密集度作為市場競爭力指標意涵為，貿易密集度越高，則此國家在外銷目標國的市場競爭力越高。本平台貿易密集度由 <b>(目標市場進口競爭國之農機總進口值 / 目標市場國進口全球之農機總進口值) / [競爭國出口全球之農機總出口值 / (農機全球總出口值-目標市場國出口全球之農機總出口值)]</b> 計算獲得。'
          }
        ],
        '零售價格分析與指標': [
          {
            title: '通路型態',
            value: '通路型態',
            content: '蔬果的訂價差異，受到不同通路鎖定目標消費者可接受價格範圍影響，比較不同通路蔬果零售價格，可作為進入不同通路時，自己產品的價格定位參考。'
          },
          {
            title: '市場所在國與產地',
            value: '市場所在國與產地',
            content: '蔬果的訂價差異，受到成本與市場消費者可接受價格影響，比較不同市場國與同一市場中競爭產品價格，可作為進入該國家，自己產品的價格定位參考。'
          },
          {
            title: '產品形式',
            value: '產品形式',
            content: '蔬果價格差異，受到不同產品形式影響，比較不同販售包裝之零售價格，可作為自己產品包裝改進與價格定位參考。'
          },
          {
            title: '照片(進階功能)',
            value: '照片(進階功能)',
            content: '為讓使用者更比較產品外觀、產品包裝與標籤等內容，此平台提供進階使用者可觀看本平台中零售端陳列照片功能，如您希望可以使用者功能，請與我們共享您的照片與資料。'
          }
        ]
      }
    },
    tutorialImgs () {
      const imgType = this.type === 'tool' ? 'tool' : 'normal'
      return {
        '市場吸引力操作教學說明': [
          {
            title: '數據搜尋',
            description: '',
            img: require('../../assets/images/tutorial-' + imgType + '-attraction-1.jpg'),
            items: [
              {
                contents: [
                  '選擇品項、年份後，按下搜尋，數據結果會顯示在右側表格。'
                ]
              },
              {
                contents: [
                  '可自行調整指標權重，會即時顯示與動態調整結果與排名。'
                ]
              },
              {
                contents: [
                  '可勾選決定是否採計該國資料，也可點選國名查看單一國歷年數據。<b>圖示代表有相關分析報告</b>。'
                ]
              },
              {
                contents: [
                  '可下載數據表格csv檔案，進階會員可載原始數據表格。'
                ]
              },
              {
                contents: [
                  '可切換到<b>分頁：統計圖呈現</b>，繪製多種統計圖。'
                ]
              }
            ]
          },
          {
            title: '統計圖呈現',
            description: '',
            img: require('../../assets/images/tutorial-' + imgType + '-attraction-2.jpg'),
            items: [
              {
                contents: [
                  '可點選<b>分頁：統計圖呈現</b>，繪製多種統計圖。'
                ]
              },
              {
                contents: [
                  '可選擇圖類型：XY散佈圖、泡泡圖、累計長條圖、雷達圖。',
                  '每種統計圖都有不同的參數可設定，如：軸的指標。',
                  '可點選<b>分頁：數據選擇</b>，勾選決定是否採計該國資料。'
                ]
              },
              {
                contents: [
                  '可點另存圖檔，下載統計圖。'
                ]
              }
            ]
          },
          {
            title: '單一國家歷年分數表',
            description: '使用者點選<span class="link">國家</span>後會跳出此分頁',
            img: require('../../assets/images/tutorial-' + imgType + '-attraction-3.jpg'),
            items: [
              {
                contents: [
                  '數據結果、統計圖呈現操作請參考上方操作。'
                ]
              },
              {
                contents: [
                  '若有相關報告，會有<b>分析報告分頁</b>，使用者可點選瀏覽與閱讀。'
                ]
              },
              {
                contents: [
                  '可點選國家概況分頁，更暸解該國家的基本資訊，如：天氣。'
                ]
              }
            ]
          },
          {
            title: '單一國家歷年數據：國家概況',
            description: '點選<b>國家概況</b>預設進入<b>天氣</b>分頁',
            img: require('../../assets/images/tutorial-' + imgType + '-attraction-4.jpg'),
            items: [
              {
                contents: [
                  '使用者可點選數字放大地圖，或點選圖標，查看氣候資訊與繪製'
                ]
              },
              {
                contents: [
                  '站點的基本資訊會呈現於此，若需要更完整氣候資訊，可點連結到NOAA網站查詢。'
                ]
              },
              {
                contents: [
                  '選好站點後，可切換日/月資料查看不同範圍的天氣歷史資料。'
                ]
              },
              {
                contents: [
                  '可選擇起訖時間後按繪圖，該區間折線圖會呈現於右側。'
                ]
              },
              {
                contents: [
                  '使用者可以下載該統計圖，也可下載該區間天氣數據csv檔案。'
                ]
              }
            ]
          }
        ],
        '市場競爭力操作教學說明': [
          {
            title: '數據搜尋',
            description: '',
            img: require('../../assets/images/tutorial-' + imgType + '-competitiveness-1.jpg'),
            items: [
              {
                contents: [
                  '選擇品項、年份後，按下搜尋，數據結果會顯示在右側表格。'
                ]
              },
              {
                contents: [
                  '可自行調整指標權重，會即時顯示與動態調整結果與排名。'
                ]
              },
              {
                contents: [
                  '可勾選決定是否採計該國資料，也可點選國名查看單一國歷年數據。<b>圖示代表有相關分析報告</b>。'
                ]
              },
              {
                contents: [
                  '可下載數據表格csv檔案，進階會員可載原始數據表格。'
                ]
              },
              {
                contents: [
                  '可切換到<b>分頁：統計圖呈現</b>，繪製多種統計圖。'
                ]
              }
            ]
          },
          {
            title: '統計圖呈現',
            description: '',
            img: require('../../assets/images/tutorial-' + imgType + '-competitiveness-2.jpg'),
            items: [
              {
                contents: [
                  '可點選<b>分頁：統計圖呈現</b>，繪製多種統計圖。'
                ]
              },
              {
                contents: [
                  '可選擇圖類型：XY散佈圖、泡泡圖、累計長條圖、雷達圖。',
                  '每種統計圖都有不同的參數可設定，如：軸的指標。',
                  '可點選<b>分頁：數據選擇</b>，勾選決定是否採計該國資料。'
                ]
              },
              {
                contents: [
                  '可點另存圖檔，下載統計圖。'
                ]
              }
            ]
          },
          {
            title: '單一國家歷年分數表',
            description: '使用者點選<span class="link">國家</span>後會跳出此分頁',
            img: require('../../assets/images/tutorial-' + imgType + '-competitiveness-3.jpg'),
            items: [
              {
                contents: [
                  '數據結果、統計圖呈現操作請參考上方操作。'
                ]
              },
              {
                contents: [
                  '若有相關報告，會有<b>分析報告分頁</b>，使用者可點選瀏覽與閱讀。'
                ]
              },
              {
                contents: [
                  '可點選國家概況分頁，更暸解該國家的基本資訊，如：天氣。'
                ]
              }
            ]
          },
          {
            title: '單一國家歷年數據：國家概況',
            description: '點選<b>國家概況</b>預設進入<b>天氣</b>分頁',
            img: require('../../assets/images/tutorial-' + imgType + '-competitiveness-4.jpg'),
            items: [
              {
                contents: [
                  '使用者可點選數字放大地圖，或點選圖標，查看氣候資訊與繪製'
                ]
              },
              {
                contents: [
                  '站點的基本資訊會呈現於此，若需要更完整氣候資訊，可點連結到NOAA網站查詢。'
                ]
              },
              {
                contents: [
                  '選好站點後，可切換日/月資料查看不同範圍的天氣歷史資料。'
                ]
              },
              {
                contents: [
                  '可選擇起訖時間後按繪圖，該區間折線圖會呈現於右側。'
                ]
              },
              {
                contents: [
                  '使用者可以下載該統計圖，也可下載該區間天氣數據csv檔案。'
                ]
              }
            ]
          }
        ],
        '零售價格分析操作教學說明': [
          {
            title: '數據搜尋',
            description: '',
            img: require('../../assets/images/tutorial-product-price-1.jpg'),
            items: [
              {
                contents: [
                  '使用者可選擇產品類別、產品名稱，按下搜尋，結果會顯示於右側作圖區。'
                ]
              },
              {
                contents: [
                  '可選擇X、Z軸的指標來繪製散佈圖，並可選擇要顯示的資料集。'
                ]
              },
              {
                contents: [
                  '可點選圖面上的資料點，查看單一筆數據及其鄰近條件數據的詳細資訊。'
                ]
              },
              {
                contents: [
                  '可以點另存圖檔，下載當前顯示的統計圖。',
                  '<b>進階使用者</b>可點原始數據下載，獲取該產品零售價格之詳細資訊與照片。'
                ]
              },
              {
                contents: [
                  '<b>進階使用者</b>可新增上傳零售價格資料，並能在上傳記錄分頁看到過往的記錄。'
                ]
              }
            ]
          },
          {
            title: '零售價格詳細資料',
            description: '<span class="dark">使用者點選<b>單一圖點</b>後會跳出此分頁<span>',
            img: require('../../assets/images/tutorial-product-price-2.jpg'),
            items: [
              {
                contents: [
                  '頁面會呈現單一筆數據及其鄰近條件數據群列表，使用者可以點選分頁瀏覽列表。',
                  '每筆數據的詳細資料都會呈現在下方。(照片僅供<b>進階使用者</b>操作)'
                ]
              }
            ]
          }
        ],
        '分析報告與操作說明': [
          {
            title: '瀏覽與搜尋',
            description: '',
            img: require('../../assets/images/tutorial-report-1.jpg'),
            items: [
              {
                contents: [
                  '報告會按照日期新舊排序，使用者可點選<span class="link">更多內容</span>閱讀報告內容。',
                  '使用者可查看<span class="link">標籤</span>，或點選<span class="link">標籤</span>，來搜尋相關報告。'
                ]
              },
              {
                contents: [
                  '可輸入各種條件來搜尋報告。'
                ]
              }
            ]
          },
          {
            title: '閱讀報告',
            description: '',
            img: require('../../assets/images/tutorial-report-2.jpg'),
            items: [
              {
                contents: [
                  '使用者可閱讀報告內容。也可查看<span class="link">標籤</span>，或點選<span class="link">標籤</span>，來搜尋相關報告。'
                ]
              },
              {
                contents: [
                  '<b>進階使用者</b>可下載報告內的附件檔案與對報告文章留言。'
                ]
              }
            ]
          }
        ]
      }
    }
  },
  created () {
    this.renderItem = this.params.renderItem || {
      '農產業貿易潛力分析平台': true,
      '市場吸引力分析': true,
      '市場吸引力指標': true,
      '市場吸引力操作教學說明': true,
      '市場競爭力分析': true,
      '市場競爭力指標': true,
      '市場競爭力操作教學說明': true,
      '零售價格分析與指標': true,
      '零售價格分析操作教學說明': true,
      '分析報告與操作說明': true
    }
    this.display = this.params.display || {
      '農產業貿易潛力分析平台': null,
      '市場吸引力分析': true,
      '市場吸引力指標': true,
      '市場吸引力操作教學說明': true,
      '市場競爭力分析': true,
      '市場競爭力指標': true,
      '市場競爭力操作教學說明': true,
      '零售價格分析與指標': true,
      '零售價格分析操作教學說明': true,
      '分析報告與操作說明': true
    }
    this.toggle = this.params.toggle || {
      '農產品使用的吸引力指標': null,
      '農業機械使用的吸引力指標': null,
      '農產品使用的競爭力指標': null,
      '農業機械使用的競爭力指標': null,
      '零售價格分析與指標': null
    }
  },
  mounted () {
    if (this.$route.query.to) {
      this.scrollTo(this.$route.query.to, false)
    }
  },
  watch: {
    'scrollToID' (nv, ov) {
      if (nv && nv !== ov) {
        this.scrollTo(nv)
      }
    }
  },
  methods: {
    scrollTo (id, animated = true) {
      this.display[id] = true
      let target = document.getElementById(id)
      target && target.scrollIntoView({ behavior: animated ? 'smooth' : 'auto' })
    },
    toggleCard (type, card) {
      this.toggle[type] = this.toggle[type] !== card ? card : null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tutorial/main.vue